import React from "react";
import "./ResetPassword.scss";
import Image from "../../components/image/Image";
import { AppIcons } from "../../data/appIcons";
import ResetPasswordForm from "../../features/resetPassword/ResetPasswordForm";

const ResetPassword = () => {
  return (
    <div className="main-login-section">
      <div className="min-h-full flex items-center justify-center w-full login-wrapper">
        <div className="login-main-bg">
          <div>
            <Image
              imagePath={AppIcons.logoImage}
              imgCustomClassName="open-bar"
              altText="Icon"
            ></Image>
          </div>
          <div className="text-center">
            <h2 style={{ textAlign: "center", color: "#1e4620", fontSize: "26px", fontWeight: "600", margin: "25px 0 25px 0" }}>
              New Password
            </h2>
          </div>
          <div>
            <ResetPasswordForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
